import React, { ReactElement } from 'react';
import { PebbleWarning } from '@ds/icons';
import { ContainerLayout } from 'layouts';
import { TranslationContext } from '@ds/react-utils';
import { HeaderIconContainer } from 'components/shared';
import { configuration } from 'services';
import ErrorCallbackComponent from './components/ErrorCallbackComponent';

export type SupportedErrorType = 'AttemptsExceeded' | 'RejectedInput' | 'Unspecified';

const DocumentLockedPage = (): ReactElement => {
    const translate = React.useContext(TranslationContext);
    const enableErrorCallback = configuration.enableErrorCallback();

    if (enableErrorCallback) {
        return <ErrorCallbackComponent />;
    }

    return (
        <ContainerLayout>
            <ContainerLayout.Header>
                <HeaderIconContainer data-qa="verify-document-locked-error-picto">
                    <PebbleWarning width="48px" height="48px" viewBox="1 1 22 22" />
                </HeaderIconContainer>
                <ContainerLayout.Header.Title
                    titleDataQa="verify-document-locked-title"
                    title={translate("You've reached the authentication limit")}
                />
            </ContainerLayout.Header>

            <ContainerLayout.InnerContent dataQa="verify-document-locked-content">
                <p>{translate('You have made the maximum number of attempts allowed.')}</p>
                <p>{translate('We have notified the person or organization requesting this identity verification.')}</p>
            </ContainerLayout.InnerContent>
        </ContainerLayout>
    );
};

export default DocumentLockedPage;
